import * as React from 'react'

interface ITripHistoryDetailSection {
  title: any
}

class TripHistoryDetailSection extends React.Component<ITripHistoryDetailSection, any> {
  public render() {
    return (
      <React.Fragment>
        <div className='h5 mb1 bold'>{this.props.title}</div>
        {this.props.children}
      </React.Fragment>
    )
  }
}

export default TripHistoryDetailSection



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryDetailSection.tsx